import * as React from "react"

import {
    AcceptInviteDialog,
    SendApplicationDialog,
    MonumentAchievementsDialog,
    OldRecommendationsSettingsDialog,
} from "../Containers/"

import { showDialog } from "fe2/Actions/ActionDialog"

export const showSendApplicationDialog = (clan, sourceName, shouldFetchApplications = false) => showDialog(<SendApplicationDialog clan={clan} source={sourceName} shouldFetchApplications={shouldFetchApplications} />, 'small')

export const showAcceptInviteDialog = (invite) => showDialog(<AcceptInviteDialog invite={invite} />, 'small')

export const showMonumentAchievementsDialog = (clanId: any) => showDialog(<MonumentAchievementsDialog clanId={clanId} />, 'overlay', true)

export const showOldRecommendationsSettingsDialog = () => (
    showDialog(<OldRecommendationsSettingsDialog />, 'fullscreen')
)